import ClockIcon from "../../Theme/CustomIcons/Icons/Time/ClockIcon";
import VacationIcon from "../../Theme/CustomIcons/Icons/CustomIcons/VacationIcon";
import ActivityIcon from "../../Theme/CustomIcons/Icons/Business/ActivityIcon";
import TaskSquareIcon from "../../Theme/CustomIcons/Icons/ContentEdit/TaskSquareIcon";
import NotificationStatusIcon from "../../Theme/CustomIcons/Icons/Notification/NotificationStatusIcon";
import CalculatorIcon from "../../Theme/CustomIcons/Icons/School,Learning/CalculatorIcon";
import TransactionMinusIcon from "../../Theme/CustomIcons/Icons/Money/TransactionMinusIcon";
import PeopleIcon from "../../Theme/CustomIcons/Icons/Users/PeopleIcon";
// import HelpDeskIcon from "../../Theme/CustomIcons/Icons/CoomputerDevicesElectronics/HelpDeskIcon";
import OfficeBagIcon from "../../Theme/CustomIcons/Icons/Shop/OfficeBagIcon";
import SmsIcon from "../../Theme/CustomIcons/Icons/Emails,Messages/SmsIcon";
import TeacherIcon from "../../Theme/CustomIcons/Icons/School,Learning/TeacherIcon";
import HelpDeskIcon from "../../Theme/CustomIcons/Icons/ComputerDevicesElectronics/HelpDeskIcon";
import CalanderEditIcon from "../../Theme/CustomIcons/Icons/Time/CalanderEditIcon";
import AwardIcon from "../../Theme/CustomIcons/Icons/School,Learning/AwardIcon";
import DashboardIcon from "../../Icons/DashboardIcon";
import TrainingIcon from "../../Icons/TrainingIcon";
import { RecruitmentIcon } from "../../Icons/RecruitmentIcons";
import TimesheetIcon from "../../Icons/TimesheetIcon";
import LeaveIcon from "../../Icons/LeaveIcon";
import CalendarIcon from "../../Icons/CalendarIcon";
import TeamsIcon from "../../Icons/TeamsIcon";
import ServiceRequestIcon from "../../Icons/ServiceRequestIcon";
import ReportIcon from "../../Icons/ReportIcon";

import WeightIcon from "../../Theme/CustomIcons/Icons/Essetional/WeightIcon";
import Profile2UserIcon from "../../Theme/CustomIcons/Icons/Users/Profile2UserIcon";
import UserOctagonIcon from "../../Theme/CustomIcons/Icons/Users/UserOctagonIcon";
import BookIcon from "../../Theme/CustomIcons/Icons/CustomIcons/BookIcon";
import ComputerMsgIcon from "../../Theme/CustomIcons/Icons/CustomIcons/ComputerMsgIcon";
export const headerDrawerData = (sharedUserInfo) => {
  let userType = "";
  if (sharedUserInfo?.payload) {
    userType = sharedUserInfo?.payload?.type;
  } else {
    userType = sharedUserInfo?.type;
  }
  const roleFeatures = sharedUserInfo.userAccess;
  let industry;
  if (sharedUserInfo?.payload?.company) {
    industry =
      sharedUserInfo?.payload?.company?.modules?.length > 0
        ? sharedUserInfo?.payload?.company?.modules
        : [];
  } else {
    industry =
      sharedUserInfo?.empCompanies[0]?.companyId?.modules?.length > 0
        ? sharedUserInfo?.empCompanies[0]?.companyId?.modules
        : [];
  }
  return [
    {
      // key: `/${userType === "admin" ? userType : "manager"}/job-posts`,
      // label: "Recruitment",
      // children: [
      //   {
      //     key: `/${userType === "admin" ? userType : "manager"}/job-posts`,
      //     icon: (
      //       <RecruitmentIcon
      //         style={{ fontSize: "20px" }}
      //         className={"sidebar-icon-color"}
      //         id="recruitment"
      //       />
      //     ),
      //     label: "Job Posts",
      //     link: `/${userType === "admin" ? userType : "manager"}/job-posts`,
      //     show:
      //       userType === "admin" ||
      //       userType === "guest" ||
      //       (userType !== "user" &&
      //         (roleFeatures?.includes("67") ||
      //           roleFeatures?.includes("69") ||
      //           roleFeatures?.includes("70"))),
      //     category: "AI",
      //   },
      // ],
      show: true,
      category: "ask max",
    },
    {
      key: `/${userType === "admin" ? userType : "manager"}/dashboard/`,
      icon: <DashboardIcon className="sidebar-icon-color" />,
      label: "Dashboard",
      link: `/${userType === "admin" ? userType : "manager"}/dashboard/`,
      show: userType !== "user",
      category: "none",
    },
    {
      key: `/${userType === "admin" ? userType : "manager"}/activity/`,
      label: "time",
      show:
        industry.includes("time_tracking_desktop") ||
        industry.includes("time") ||
        userType === "admin" ||
        (userType !== "user" &&
          (roleFeatures?.includes("88") ||
            roleFeatures?.includes("82") ||
            roleFeatures?.includes("85") ||
            roleFeatures?.includes("89") ||
            roleFeatures?.includes("19") ||
            roleFeatures?.includes("20") ||
            roleFeatures?.includes("61") ||
            roleFeatures?.includes("21"))),
      // show: false,
      viewType: "box-view",
      category: "time",
      children: [
        {
          key: `/${userType === "admin" ? userType : "manager"}/timesheet/`,
          icon: <ClockIcon size="large" />,
          label: "Timesheet",
          link: `/${userType === "admin" ? userType : "manager"}/timesheet/`,
          show:
            userType === "admin" ||
            (userType !== "user" &&
              (roleFeatures?.includes("88") ||
                roleFeatures?.includes("82") ||
                roleFeatures?.includes("85"))),
          viewType: "box-view",
          category: "time",
          siblings: [
            `/${userType === "admin" ? userType : "manager"}/timesheet`,
          ],
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/leave-request/`,
          icon: <VacationIcon size="large" color="black" />,
          label: "Leave Request",
          link:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("20"))
              ? `/${userType === "admin" ? userType : "manager"}/leave-request/`
              : userType === "admin" ||
                (userType !== "user" && roleFeatures?.includes("21"))
              ? `/${userType === "admin" ? userType : "manager"}/leave-history`
              : `/${
                  userType === "admin" ? userType : "manager"
                }/leave-calendar`,
          show:
            (industry.includes("leave") ||
              industry.includes("advanced_leave")) &&
            (userType === "admin" ||
              (userType !== "user" && roleFeatures?.includes("20")) ||
              roleFeatures?.includes("21")),
          viewType: "box-view",
          category: "time",
          siblings: [
            `/${userType === "admin" ? userType : "manager"}/leave-request`,
            `/${userType === "admin" ? userType : "manager"}/leave-history`,
            `/${userType === "admin" ? userType : "manager"}/leave-calendar`,
            `/${userType === "admin" ? userType : "manager"}/my-leaves`,
          ],
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/shift/`,
          icon: <CalanderEditIcon size="large" color="black" />,
          label: "Shift Assignment",
          link: `/${userType === "admin" ? userType : "manager"}/shift/`,
          show:
            industry.includes("shift") &&
            (userType === "admin" ||
              (userType !== "user" &&
                (roleFeatures?.includes("19") ||
                  roleFeatures?.includes("20") ||
                  roleFeatures?.includes("82") ||
                  roleFeatures?.includes("85") ||
                  roleFeatures?.includes("21")))),
          // show:
          // industry.includes("shift") &&
          // (userType === "admin" ||
          //   (userType !== "user" && roleFeatures?.includes("19"))),
          viewType: "box-view",
          category: "time",
          siblings: [],
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/activity/`,
          icon: <ActivityIcon size="large" color="black" />,
          label: "Activity",
          link: `/${userType === "admin" ? userType : "manager"}/activity/`,
          show:
            // (userType === "admin" ||
            //   (userType !== "user" && roleFeatures?.includes("19"))) &&
            industry.includes("time_tracking_desktop"),
          viewType: "box-list-view",
          category: "time",
          siblings: [],
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/project/`,
          icon: <TaskSquareIcon size="large" color="black" />,
          label: "Projects",
          link: `/${userType === "admin" ? userType : "manager"}/project/`,
          show:
            // (userType === "admin" ||
            //   (userType !== "user" && roleFeatures?.includes("19"))) &&
            industry.includes("time_tracking_desktop"),
          viewType: "box-list-view",
          category: "time",
          siblings: [],
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/work-status/`,
          icon: <NotificationStatusIcon size="large" color="black" />,
          label: "Work Status",
          link: `/${userType === "admin" ? userType : "manager"}/work-status/`,
          show:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("104")),
          viewType: "box-view",
          category: "time",
          siblings: [],
        },
      ],
    },
    {
      key: `/${userType === "admin" ? userType : "manager"}/payrollcom`,
      label: "Payroll Events",
      show:
        userType !== "user" &&
        industry.includes("payroll") &&
        (userType === "admin" ||
          (userType !== "user" &&
            (roleFeatures?.includes("44") ||
              roleFeatures?.includes("45") ||
              roleFeatures?.includes("46") ||
              roleFeatures?.includes("47") ||
              roleFeatures?.includes("48") ||
              roleFeatures?.includes("49") ||
              roleFeatures?.includes("50") ||
              roleFeatures?.includes("51") ||
              roleFeatures?.includes("52") ||
              roleFeatures?.includes("53") ||
              roleFeatures?.includes("54") ||
              roleFeatures?.includes("55") ||
              roleFeatures?.includes("56") ||
              roleFeatures?.includes("57") ||
              roleFeatures?.includes("105") ||
              roleFeatures?.includes("58") ||
              roleFeatures?.includes("59") ||
              roleFeatures?.includes("60") ||
              roleFeatures?.includes("74") ||
              roleFeatures?.includes("75") ||
              roleFeatures?.includes("76") ||
              roleFeatures?.includes("77")))),
      viewType: "box-view",
      category: "payroll",
      children: [
        {
          key: `/${userType === "admin" ? userType : "manager"}/payroll/`,
          icon: <CalculatorIcon size="large" color="black" />,
          label: "Process Payroll",
          link: `/${userType === "admin" ? userType : "manager"}/payroll/`,
          show: userType !== "guest" && userType !== "user",
          viewType: "box-view",
          category: "payroll",
          siblings: [
            `/${userType === "admin" ? userType : "manager"}/payroll-preview`,
            `/${userType === "admin" ? userType : "manager"}/payroll-preview/`,
            `/${userType === "admin" ? userType : "manager"}payroll-review/`,
            `/${
              userType === "admin" ? userType : "manager"
            }/payroll-process-hours/`,
            `/${userType === "admin" ? userType : "manager"}/payroll-leave/`,
            `/${
              userType === "admin" ? userType : "manager"
            }/payroll-additional-pay/`,
            `/${userType === "admin" ? userType : "manager"}/payroll-review/`,
            `/${
              userType === "admin" ? userType : "manager"
            }/payroll-additional-pay/`,
            `/${userType === "admin" ? userType : "manager"}/payroll`,
          ],
        },
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/expense-request/`,
          icon: <TransactionMinusIcon size="large" color="black" />,
          label: "Expense Request",
          link:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("105"))
              ? `/${
                  userType === "admin" ? userType : "manager"
                }/expense-request/`
              : `/${
                  userType === "admin" ? userType : "manager"
                }/expense-history/`,

          show:
            userType === "admin" ||
            (userType !== "user" &&
              (roleFeatures?.includes("105") || roleFeatures?.includes("106"))),
          viewType: "box-view",
          category: "payroll",
          siblings: [
            `/${userType === "admin" ? userType : "manager"}/expense-history`,
            `/${userType === "admin" ? userType : "manager"}/expense-request`,
            `/${userType === "admin" ? userType : "manager"}/expense-history/`,
            `/${userType === "admin" ? userType : "manager"}/expense-request/`,
          ],
        },
      ],
    },

    {
      key: `/${userType === "admin" ? userType : "manager"}/job-posts`,
      label: "Grow",
      show:
        userType === "admin" ||
        userType === "guest" ||
        (userType !== "user" &&
          (roleFeatures?.includes("67") ||
            roleFeatures?.includes("68") ||
            roleFeatures?.includes("93") ||
            roleFeatures?.includes("69") ||
            roleFeatures?.includes("70"))),
      viewType: "box-view",
      category: "recruitment",
      children: [
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/onboarding-tasks/`,
          //icon needs to be changed
          icon: <NotificationStatusIcon size="large" color="black" />,
          label: "Onboarding",
          link:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("93"))
              ? `/${
                  userType === "admin" ? userType : "manager"
                }/onboarding-tasks/`
              : `/${
                  userType === "admin" ? userType : "manager"
                }/onboarding-templates/`,

          show:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("93")) ||
            roleFeatures?.includes("92"),
          viewType: "box-view",
          category: "recruitment",
          siblings: [
            `/${
              userType === "admin" ? userType : "manager"
            }/onboarding-templates/`,
            `/${userType === "admin" ? userType : "manager"}/onboarding-tasks/`,
          ],
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/job-posts`,
          icon: <AwardIcon size="large" color="black" />,
          label: "Job Posts",
          link: `/${userType === "admin" ? userType : "manager"}/job-posts`,
          show:
            userType === "admin" ||
            userType === "guest" ||
            (userType !== "user" &&
              (roleFeatures?.includes("67") ||
                roleFeatures?.includes("69") ||
                roleFeatures?.includes("70"))),
          viewType: "box-view",
          category: "recruitment",
          siblings: [
            `/${userType === "admin" ? userType : "manager"}/job-posts/create`,
            `/${
              userType === "admin" ? userType : "manager"
            }/job-posts/duplicate`,
            `/${userType === "admin" ? userType : "manager"}/job-posts/edit`,
            `/${userType === "admin" ? userType : "manager"}/job-posts`,
          ],
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/talent-pool`,
          icon: <TeacherIcon size="large" color="black" />,
          label: "Talent Pool",
          link: `/${userType === "admin" ? userType : "manager"}/talent-pool`,
          show: true,
          viewType: "box-view",
          category: "recruitment",
          siblings: [],
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/training/`,
          icon: <BookIcon size="large" color="black" />,
          label: "Training",
          link: `/${userType === "admin" ? userType : "manager"}/training/`,
          show:
            (userType === "admin" ||
              ["71", "72", "73"].some((feature) =>
                roleFeatures?.includes(feature)
              )) &&
            industry.includes("training"),
          category: "organization",
          siblings: [],
        },
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/performance-management/`,
          icon: <TaskSquareIcon size="large" color="black" />,
          label: "Performance Management",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/performance-management/`,
          show:
            (userType === "admin" ||
              (userType !== "user" && roleFeatures?.includes("4"))) &&
            industry.includes("performance"),
          category: "organization",
          siblings: [],
        },
      ],
    },
    {
      key: `/${userType === "admin" ? userType : "manager"}/companyetc`,
      label: "Company",
      show: userType !== "user",
      viewType: "box-view",
      category: "company",
      children: [
        {
          key: `/${userType === "admin" ? userType : "manager"}/employees/`,
          icon: <PeopleIcon size="large" color="black" />,
          label: "Employees",
          link: `/${userType === "admin" ? userType : "manager"}/employees/`,
          show: true,
          viewType: "box-view",
          category: "organization",
          siblings: [],
        },

        {
          key: `/${userType === "admin" ? userType : "manager"}/teams/`,
          icon: <Profile2UserIcon size="large" color="black" />,
          label: "Departments/ Teams",
          link: `/${userType === "admin" ? userType : "manager"}/teams/`,
          show:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("11")),
          viewType: "box-view",
          category: "organization",
          siblings: [],
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/help-desk/`,

          icon: <ComputerMsgIcon size="large" color="black" />,
          label: "Help Desk",
          link:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("91"))
              ? `/${userType === "admin" ? userType : "manager"}/help-desk/`
              : userType === "admin" ||
                (userType !== "user" && roleFeatures?.includes("103"))
              ? `/${userType === "admin" ? userType : "manager"}/travel-desk/`
              : `/${
                  userType === "admin" ? userType : "manager"
                }/performance-management/`,
          show:
            userType === "admin" ||
            (userType !== "user" &&
              (roleFeatures?.includes("91") ||
                roleFeatures?.includes("103") ||
                roleFeatures?.includes("4"))),
          viewType: "box-view",
          category: "organization",
          siblings: [
            `/${userType === "admin" ? userType : "manager"}/travel-desk/`,
            `/${userType === "admin" ? userType : "manager"}/help-desk/`,
          ],
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/hr-letter/`,
          //icon needs to be changed
          icon: <NotificationStatusIcon size="large" color="black" />,
          label: "HR Letters",
          link: `/${userType === "admin" ? userType : "manager"}/hr-letter/`,

          show:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("95")),
          viewType: "box-view",
          category: "organization",
          siblings: [],
        },
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/employee-hierarchy/`,
          icon: <UserOctagonIcon className="sidebar-icon-color" />,
          label: "Employee Hierarchy",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/employee-hierarchy/`,
          show:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("90")),
          viewType: "box-view",
          category: "organization",
          siblings: [],
        },
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/company-resources/`,
          //icon needs to be changed
          icon: <OfficeBagIcon size="large" color="black" />,
          label: "Company Resources",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/company-resources/`,
          show:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("94")),
          viewType: "box-view",
          category: "organization",
          siblings: [],
        },
      ],
    },
  ];
};
export const menuItems = (sharedUserInfo) => {
  let userType = "";
  if (sharedUserInfo?.payload) {
    userType = sharedUserInfo?.payload?.type;
  } else {
    userType = sharedUserInfo?.type;
  }
  const roleFeatures = sharedUserInfo.userAccess;
  let industry;
  if (sharedUserInfo?.payload?.company) {
    industry =
      sharedUserInfo?.payload?.company?.modules?.length > 0
        ? sharedUserInfo?.payload?.company?.modules
        : [];
  } else {
    industry =
      sharedUserInfo?.empCompanies[0]?.companyId?.modules?.length > 0
        ? sharedUserInfo?.empCompanies[0]?.companyId?.modules
        : [];
  }
  return [
    {
      // key: `/${userType === "admin" ? userType : "manager"}/job-posts`,
      // label: "Recruitment",
      // children: [
      //   {
      //     key: `/${userType === "admin" ? userType : "manager"}/job-posts`,
      //     icon: (
      //       <RecruitmentIcon
      //         style={{ fontSize: "20px" }}
      //         className={"sidebar-icon-color"}
      //         id="recruitment"
      //       />
      //     ),
      //     label: "Job Posts",
      //     link: `/${userType === "admin" ? userType : "manager"}/job-posts`,
      //     show:
      //       userType === "admin" ||
      //       userType === "guest" ||
      //       (userType !== "user" &&
      //         (roleFeatures?.includes("67") ||
      //           roleFeatures?.includes("69") ||
      //           roleFeatures?.includes("70"))),
      // viewType:'box-view',//
      category: "AI",
      //   },
      // ],
      show: true,
      viewType: "box-view",
      category: "AI",
    },
    {
      key: `/${userType === "admin" ? userType : "manager"}/dashboard/`,
      icon: <DashboardIcon className="sidebar-icon-color" />,
      label: "Dashboard",
      link: `/${userType === "admin" ? userType : "manager"}/dashboard/`,
      show: userType !== "user",
      viewType: "box-view",
      category: "none",
    },
    {
      key: `/${userType === "admin" ? userType : "manager"}/recruitment/`,
      icon: (
        <RecruitmentIcon
          style={{ fontSize: "20px" }}
          className={"sidebar-icon-color"}
          id="recruitment"
        />
      ),
      label: "Recruitment",
      link: `/${userType === "admin" ? userType : "manager"}/recruitment/`,
      // show: industry === "recruitment",
      show: false,
      viewType: "box-view",
      category: "recruitment",
    },
    {
      key: `/${userType === "admin" ? userType : "manager"}/job-posts`,
      label: "Recruitment",
      children: [
        {
          key: `/${userType === "admin" ? userType : "manager"}/job-posts`,
          icon: (
            <RecruitmentIcon
              style={{ fontSize: "20px" }}
              className={"sidebar-icon-color"}
              id="recruitment"
            />
          ),
          label: "Job Posts",
          link: `/${userType === "admin" ? userType : "manager"}/job-posts`,
          show:
            userType === "admin" ||
            userType === "guest" ||
            (userType !== "user" &&
              (roleFeatures?.includes("67") ||
                roleFeatures?.includes("69") ||
                roleFeatures?.includes("70"))),
          viewType: "box-view",
          category: "recruitment",
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/talent-pool`,
          icon: (
            <RecruitmentIcon
              style={{ fontSize: "20px" }}
              className={"sidebar-icon-color"}
              id="recruitment"
            />
          ),
          label: "Talent Pool",
          link: `/${userType === "admin" ? userType : "manager"}/talent-pool`,
          show: true,
          viewType: "box-view",
          category: "recruitment",
        },
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/recruitment-companies`,
          icon: (
            <RecruitmentIcon
              style={{ fontSize: "20px" }}
              className={"sidebar-icon-color"}
              id="companies"
            />
          ),
          label: "Companies",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/recruitment-companies`,
          show: industry.includes("recruitment_companies"),
          viewType: "box-view",
          category: "recruitment",
        },
      ],
      show: true,
      viewType: "box-view",
      category: "recruitment",
    },
    // {
    //   key: `/${userType === "admin" ? userType : "manager"}/job-posts`,
    //   label: "Work Flow",
    //   children: [
    //     {
    //       key: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/stage-templates`,
    //       icon: (
    //         <RecruitmentIcon
    //           style={{ fontSize: "20px" }}
    //           className={"sidebar-icon-color"}
    //           id="recruitment"
    //         />
    //       ),
    //       label: "Stage Templates",
    //       link: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/stage-templates`,
    //       show: true,
    // viewType:'box-view',//
    // category: "recruitment",
    //     },
    //   ],
    //   show: true,
    // viewType:'box-view',//
    // category: "recruitment",
    // },
    {
      key: `/${userType === "admin" ? userType : "manager"}/activity/`,
      label: "Productivity Management",
      children: [
        {
          key: `/${userType === "admin" ? userType : "manager"}/activity/`,
          icon: <ActivityIcon className="sidebar-icon-color" />,
          label: "Activity",
          link: `/${userType === "admin" ? userType : "manager"}/activity/`,
          show:
            (userType === "admin" ||
              (userType !== "user" &&
                (roleFeatures?.includes("19") ||
                  roleFeatures?.includes("20")))) &&
            industry.includes("time_tracking_desktop"),
          viewType: "box-view",
          category: "time",
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/project/`,
          icon: <ActivityIcon className="sidebar-icon-color" />,
          label: "Projects",
          link: `/${userType === "admin" ? userType : "manager"}/project/`,
          show:
            (userType === "admin" ||
              (userType !== "user" &&
                (roleFeatures?.includes("19") ||
                  roleFeatures?.includes("20")))) &&
            industry.includes("time_tracking_desktop"),
          viewType: "box-view",
          category: "time",
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/timesheet/`,
          icon: <TimesheetIcon className="sidebar-icon-color" />,
          label: "Timesheet",
          link: `/${userType === "admin" ? userType : "manager"}/timesheet/`,
          show: userType !== "user",
          viewType: "box-view",
          category: "time",
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/qr-code/`,
          icon: <TimesheetIcon className="sidebar-icon-color" />,
          label: "QR-Code",
          link: `/${userType === "admin" ? userType : "manager"}/qr-code/`,
          show: userType !== "user",
          viewType: "box-view",
          category: "time",
        },
        // {
        //   key: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/timesheet-settings/`,
        //   icon: <TimesheetIcon className="sidebar-icon-color" />,
        //   label: "Timesheet Settings",
        //   link: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/timesheet-settings/`,
        //   show:
        //     userType === "admin" ||
        //     (userType !== "user" &&
        //       roleFeatures?.includes("61") &&
        //       (industry.includes("time_tracking_desktop") ||
        //         industry.includes("time"))),
        // viewType:'box-view',//
        // category: "time",
        // },

        {
          key: `/${userType === "admin" ? userType : "manager"}/work-status/`,
          icon: <TimesheetIcon className="sidebar-icon-color" />,
          label: "Work Status",
          link: `/${userType === "admin" ? userType : "manager"}/work-status/`,
          show:
            userType === "admin" ||
            (userType !== "user" &&
              roleFeatures?.includes("61") &&
              (industry.includes("time_tracking_desktop") ||
                industry.includes("time"))),
          viewType: "box-view",
          category: "time",
        },
        // {
        //   key: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/qr-code-settings/`,
        //   icon: <TimesheetIcon className="sidebar-icon-color" />,
        //   label: "QR Code Settings",
        //   link: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/qr-code-settings/`,
        //   show: userType !== "user",
        // viewType:'box-view',//
        // category: "time",
        // },
      ],
      show:
        industry.includes("time_tracking_desktop") ||
        (industry.includes("time") && userType !== "user"),
      viewType: "box-view",
      category: "time",
    },

    {
      key: `/${userType === "admin" ? userType : "manager"}/leaves/123123`,
      label: "Expense Management",
      children: [
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/expense-request/`,
          icon: <LeaveIcon className="sidebar-icon-color" />,
          label: "Expense Request",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/expense-request/`,
          show:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("105")),
          viewType: "box-view",
          category: "time",
        },
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/expense-history/`,
          icon: <LeaveIcon className="sidebar-icon-color" />,
          label: "Expense History",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/expense-history/`,
          show:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("106")),
          viewType: "box-view",
          category: "time",
        },
        // {
        //   key: `/${userType === "admin" ? userType : "manager"}/my-leaves/`,
        //   icon: <LeaveIcon className="sidebar-icon-color" />,
        //   label: "My Leaves",
        //   link: `/${userType === "admin" ? userType : "manager"}/my-leaves/`,
        //   show: !(userType === "admin" || userType === "user"),
        // viewType:'box-view',//
        // category: "time",
        // },
        // {
        //   key: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/expense-settings/`,
        //   icon: <LeaveIcon className="sidebar-icon-color" />,
        //   label: "Expense Settings",
        //   link: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/expense-settings/`,
        //   show:
        //     userType === "admin" ||
        //     (userType !== "user" && roleFeatures?.includes("107")),
        // viewType:'box-view',//
        // category: "time",
        // },
      ],
      show:
        userType === "admin" ||
        (userType !== "user" &&
          (roleFeatures?.includes("105") ||
            roleFeatures?.includes("106") ||
            roleFeatures?.includes("107"))),
      viewType: "box-view",
      category: "time",
    },
    {
      key: `/${userType === "admin" ? userType : "manager"}/leaves/123123`,
      label: "Leave Management",
      children: [
        {
          key: `/${userType === "admin" ? userType : "manager"}/leave-request/`,
          icon: <LeaveIcon className="sidebar-icon-color" />,
          label: "Leave Request",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/leave-request/`,
          show:
            (industry.includes("leave") ||
              industry.includes("advanced_leave")) &&
            (userType === "admin" ||
              (userType !== "user" &&
                (roleFeatures?.includes("19") ||
                  roleFeatures?.includes("20")))),
          viewType: "box-view",
          category: "time",
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/leave-history/`,
          icon: <LeaveIcon className="sidebar-icon-color" />,
          label: "Leave History",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/leave-history/`,
          show:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("21")),
          viewType: "box-view",
          category: "time",
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/my-leaves/`,
          icon: <LeaveIcon className="sidebar-icon-color" />,
          label: "My Leaves",
          link: `/${userType === "admin" ? userType : "manager"}/my-leaves/`,
          show: !(userType === "admin" || userType === "user"),
          viewType: "box-view",
          category: "time",
        },
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/leave-calendar/`,
          icon: <LeaveIcon className="sidebar-icon-color" />,
          label: "Leave Calendar",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/leave-calendar/`,
          show: userType === "admin" || userType === "user",
          viewType: "box-view",
          category: "time",
        },
        // {
        //   key: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/leave-category/`,
        //   icon: <LeaveIcon className="sidebar-icon-color" />,
        //   label: "Leave Category",
        //   link: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/leave-category/`,
        //   show: true,
        //   category: "time",
        // },
        // {
        //   key: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/leave-settings/`,
        //   icon: <LeaveIcon className="sidebar-icon-color" />,
        //   label: "Leave Settings",
        //   link: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/leave-settings/`,
        //   show:
        //     userType === "admin" ||
        //     (userType !== "user" && roleFeatures?.includes("42")),
        // viewType:'box-view',//
        // category: "time",
        // },
        // {
        //   key: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/individual-leave-settings/`,
        //   icon: <LeaveIcon className="sidebar-icon-color" />,
        //   label: "Individual Leave Settings",
        //   link: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/individual-leave-settings/`,
        //   show:
        //     userType === "admin" ||
        //     (userType !== "user" && roleFeatures?.includes("42")),
        // viewType:'box-view',//
        // category: "time",
        // },
        // {
        //   key: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/public-holidays/`,
        //   icon: <LeaveIcon className="sidebar-icon-color" />,
        //   label: "Public Holidays",
        //   link: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/public-holidays/`,
        //   show:
        //     userType === "admin" ||
        //     (userType !== "user" && roleFeatures?.includes("42")),
        // viewType:'box-view',//
        // category: "time",
        // },
      ],
      show:
        industry.includes("leave") ||
        (industry.includes("advanced_leave") &&
          (userType === "admin" ||
            (userType !== "user" &&
              (roleFeatures?.includes("19") ||
                roleFeatures?.includes("20") ||
                roleFeatures?.includes("21"))))),
      viewType: "box-view",
      category: "time",
    },
    {
      key: `/${userType === "admin" ? userType : "manager"}/shift/123123`,
      label: "Roster Management",
      children: [
        {
          key: `/${userType === "admin" ? userType : "manager"}/shift/`,
          icon: <CalendarIcon className="sidebar-icon-color" />,
          label: "Shift Assignment",
          link: `/${userType === "admin" ? userType : "manager"}/shift/`,
          show:
            industry.includes("shift") &&
            (userType === "admin" ||
              (userType !== "user" &&
                (roleFeatures?.includes("19") ||
                  roleFeatures?.includes("20") ||
                  roleFeatures?.includes("82") ||
                  roleFeatures?.includes("85") ||
                  roleFeatures?.includes("21")))),
          viewType: "box-view",
          category: "time",
        },
        // {
        //   key: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/shift-template/`,
        //   icon: <CalendarIcon className="sidebar-icon-color" />,
        //   label: "Shift Templates",
        //   link: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/shift-template/`,
        //   show:
        //     industry.includes("shift") &&
        //     (userType === "admin" ||
        //       (userType !== "user" &&
        //         (roleFeatures?.includes("19") ||
        //           roleFeatures?.includes("20") ||
        //           roleFeatures?.includes("21")))),
        // viewType:'box-view',//
        // category: "time",
        // },
      ],
      show:
        industry.includes("shift") &&
        (userType === "admin" ||
          (userType !== "user" &&
            (roleFeatures?.includes("19") ||
              roleFeatures?.includes("20") ||
              roleFeatures?.includes("82") ||
              roleFeatures?.includes("85") ||
              roleFeatures?.includes("21")))),
      viewType: "box-view",
      category: "time",
    },
    // {
    //   key: `/${
    //     userType === "admin" ? userType : "manager"
    //   }/leaves/timesheetmanagement`,
    //   label: "Timesheet Management",
    //   children: [
    //     {
    //       key: `/${userType === "admin" ? userType : "manager"}/timesheet/`,
    //       icon: <TimesheetIcon className="sidebar-icon-color" />,
    //       label: "Timesheet",
    //       link: `/${userType === "admin" ? userType : "manager"}/timesheet/`,
    //       show: userType !== "user",
    // viewType:'box-view',//
    // category: "time",
    //     },
    //   ],
    //   show: userType !== "user",
    // viewType:'box-view',//
    // category: "time",
    // },
    {
      key: `/${userType === "admin" ? userType : "manager"}/training/`,
      icon: <TrainingIcon className="sidebar-icon-color" />,
      label: "Training",
      link: `/${userType === "admin" ? userType : "manager"}/training/`,
      show:
        ((userType !== "guest" && userType === "admin") ||
          ["71", "72", "73"].some((feature) =>
            roleFeatures?.includes(feature)
          )) &&
        industry.includes("training"),
      viewType: "box-view",
      category: "organization",
    },
    {
      key: `/${userType === "admin" ? userType : "manager"}/companyetc`,
      label: "Company",
      show: userType !== "user",
      viewType: "box-view",
      category: "organization",
      children: [
        // {
        //   key: `/${userType === "admin" ? userType : "manager"}/general/`,
        //   icon: <TeamsIcon className="sidebar-icon-color" />,
        //   label: "General",
        //   link: `/${userType === "admin" ? userType : "manager"}/general/`,
        //   show: !hrmArray.includes(industry) && industry !== "recruitment",
        // viewType:'box-view',//
        // category: "organization",
        // },
        {
          key: `/${userType === "admin" ? userType : "manager"}/teams/`,
          icon: <TeamsIcon className="sidebar-icon-color" />,
          label: "Departments/ Teams",
          link: `/${userType === "admin" ? userType : "manager"}/teams/`,
          show: true,
          // (hrmArray.includes(industry) || industry === "recruitment") &&
          // (userType === "admin" ||
          //   (userType !== "user" && roleFeatures?.includes("11"))),
          viewType: "box-view",
          category: "organization",
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/employees/`,
          icon: <TeamsIcon className="sidebar-icon-color" />,
          label: "Employees",
          link: `/${userType === "admin" ? userType : "manager"}/employees/`,
          show: true,
          viewType: "box-view",
          category: "organization",
        },
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/employee-hierarchy/`,
          icon: <ServiceRequestIcon className="sidebar-icon-color" />,
          label: "Company Hierarchy",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/employee-hierarchy/`,
          show: userType !== "user",
          viewType: "box-view",
          category: "organization",
        },
        // {
        //   key: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/service-request/`,
        //   icon: <ServiceRequestIcon className="sidebar-icon-color" />,
        //   label: "Service Request",
        //   link: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/service-request/`,
        //   show: userType !== "user",
        // viewType:'box-view',//
        // category: "organization",
        // },
        {
          key: `/${userType === "admin" ? userType : "manager"}/help-desk/`,
          icon: <ServiceRequestIcon className="sidebar-icon-color" />,
          label: "Help Desk",
          link: `/${userType === "admin" ? userType : "manager"}/help-desk/`,
          show: userType !== "user",
          viewType: "box-view",
          category: "organization",
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/travel-desk/`,
          icon: <ServiceRequestIcon className="sidebar-icon-color" />,
          label: "Travel Desk",
          link: `/${userType === "admin" ? userType : "manager"}/travel-desk/`,

          show:
            userType === "admin" ||
            (userType !== "user" && roleFeatures?.includes("103")),
          viewType: "box-view",
          category: "organization",
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/announcement/`,
          icon: <TeamsIcon className="sidebar-icon-color" />,
          label: "Announcements",
          link: `/${userType === "admin" ? userType : "manager"}/announcement/`,
          show: true,
          viewType: "box-view",
          category: "organization",
        },
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/onboarding-templates/`,
          //icon needs to be changed
          icon: <ComputerMsgIcon className="sidebar-icon-color" />,
          label: "Onboarding Templates",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/onboarding-templates/`,
          show: true,
          viewType: "box-view",
          category: "organization",
        },
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/onboarding-tasks/`,
          //icon needs to be changed
          icon: <TeamsIcon className="sidebar-icon-color" />,
          label: "Onboarding Tasks",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/onboarding-tasks/`,
          show: true,
          viewType: "box-view",
          category: "organization",
        },
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/company-resources/`,
          //icon needs to be changed
          icon: <TeamsIcon className="sidebar-icon-color" />,
          label: "Company Resources",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/company-resources/`,
          show: true,
          viewType: "box-view",
          category: "organization",
        },
        {
          key: `/${userType === "admin" ? userType : "manager"}/hr-letter/`,
          //icon needs to be changed
          icon: <TeamsIcon className="sidebar-icon-color" />,
          label: "HR Letters",
          link: `/${userType === "admin" ? userType : "manager"}/hr-letter/`,
          show: true,
          viewType: "box-view",
          category: "organization",
        },
        {
          key: `/${
            userType === "admin" ? userType : "manager"
          }/email-signature-generator`,
          //icon needs to be changed
          icon: <TeamsIcon className="sidebar-icon-color" />,
          label: "Email Signature",
          link: `/${
            userType === "admin" ? userType : "manager"
          }/email-signature-generator`,
          show: true,
          viewType: "box-view",
          category: "organization",
        },
        // {
        //   key: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/report-history/`,
        //   //icon needs to be changed
        //   icon: <TeamsIcon className="sidebar-icon-color" />,
        //   label: "Download Center",
        //   link: `/${
        //     userType === "admin" ? userType : "manager"
        //   }/report-history/`,
        //   show: true,
        // viewType:'box-view',//
        // category: "organization",
        // },
      ],
    },
    // {
    //   key: `/${userType === "admin" ? userType : "manager"}/companyetc`,
    //   label: "Company Settings",
    //   show: userType !== "user",
    // viewType:'box-view',//
    // category: "organization",
    //   children: [
    //     {
    //       key: `/${userType === "admin" ? userType : "manager"}/user-role/`,
    //       icon: <TeamsIcon className="sidebar-icon-color" />,
    //       label: "User Role/ Permissions",
    //       link: `/${userType === "admin" ? userType : "manager"}/user-role/`,
    //       show: userType === "admin",
    // viewType:'box-view',//
    // category: "organization",
    //     },

    //     {
    //       key: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/organization-settings/`,
    //       icon: <TeamsIcon className="sidebar-icon-color" />,
    //       label: "Organization Settings",
    //       link: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/organization-settings/`,
    //       show: true,
    // viewType:'box-view',//
    // category: "organization",
    //     },
    //     // {
    //     //   key: `/${
    //     //     userType === "admin" ? userType : "manager"
    //     //   }/organization-basic-settings/`,
    //     //   icon: <TeamsIcon className="sidebar-icon-color" />,
    //     //   label: "Organization Settings",
    //     //   link: `/${
    //     //     userType === "admin" ? userType : "manager"
    //     //   }/organization-basic-settings/`,
    //     //   show: true,
    // viewType:'box-view',//     //
    // category: "organization",
    //     // },
    //     // {
    //     //   key: `/${
    //     //     userType === "admin" ? userType : "manager"
    //     //   }/office-settings/`,
    //     //   icon: <TeamsIcon className="sidebar-icon-color" />,
    //     //   label: "Office Locations/ Geofencing",
    //     //   link: `/${
    //     //     userType === "admin" ? userType : "manager"
    //     //   }/office-settings/`,
    //     //   show: true,
    // viewType:'box-view',//     //
    // category: "organization",
    //     // },
    //     {
    //       key: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/manage-branches/`,
    //       icon: <TeamsIcon className="sidebar-icon-color" />,
    //       label: "Manage Branches",
    //       link: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/manage-branches/`,
    //       show: true,
    // viewType:'box-view',//
    // category: "organization",
    //     },

    //     {
    //       key: `/${userType === "admin" ? userType : "manager"}/bulk-import/`,
    //       icon: <TeamsIcon className="sidebar-icon-color" />,
    //       label: "Bulk Import",
    //       link: `/${userType === "admin" ? userType : "manager"}/bulk-import/`,
    //       show: true,
    // viewType:'box-view',//
    // category: "organization",
    //     },
    //     {
    //       key: `/${userType === "admin" ? userType : "manager"}/custom-fields/`,
    //       icon: <TeamsIcon className="sidebar-icon-color" />,
    //       label: "Custom Fields",
    //       link: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/custom-fields/`,
    //       show: true,
    // viewType:'box-view',//
    // category: "organization",
    //     },
    //     {
    //       key: `/${userType === "admin" ? userType : "manager"}/all-imports/`,
    //       icon: <TeamsIcon className="sidebar-icon-color" />,
    //       label: "All Imports",
    //       link: `/${userType === "admin" ? userType : "manager"}/all-imports/`,
    //       show: true,
    // viewType:'box-view',//
    // category: "organization",
    //     },
    //     {
    //       key: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/email-templates`,
    //       icon: (
    //         <RecruitmentIcon
    //           style={{ fontSize: "20px" }}
    //           className={"sidebar-icon-color"}
    //           id="recruitment"
    //         />
    //       ),
    //       label: "Email Templates",
    //       link: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/email-templates`,
    //       show: true,
    // viewType:'box-view',//
    // category: "recruitment",
    //     },
    //   ],
    // },
    {
      key: `/${userType === "admin" ? userType : "manager"}/payrollcom`,
      label: "Payroll Events",
      show: userType !== "user" && industry.includes("payroll"),
      viewType: "box-view",
      category: "payroll",
      children: [
        {
          key: `/${userType === "admin" ? userType : "manager"}/payroll/`,
          icon: <ReportIcon className="sidebar-icon-color" />,
          label: "Process Payroll",
          link: `/${userType === "admin" ? userType : "manager"}/payroll/`,
          show: userType !== "guest" && userType !== "user",
          viewType: "box-view",
          category: "payroll",
        },
      ],
    },
    // {
    //   key: `/${userType === "admin" ? userType : "manager"}/payrollcom`,
    //   label: "Payroll Setting",
    //   show: userType !== "user",
    // viewType:'box-view',//
    // category: "payroll",
    //   children: [
    //     {
    //       key: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/payroll-basic-settings/`,
    //       icon: <ReportIcon className="sidebar-icon-color" />,
    //       label: "Payroll Type",
    //       link: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/payroll-basic-settings/`,
    //       show: true,
    // viewType:'box-view',//
    // category: "payroll",
    //     },
    //     {
    //       key: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/payroll-employee-details/`,
    //       icon: <ReportIcon className="sidebar-icon-color" />,
    //       label: "Employee Pay Breakdown",
    //       link: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/payroll-employee-details/`,
    //       show: true,
    // viewType:'box-view',//
    // category: "payroll",
    //     },
    //     {
    //       key: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/salary-components/`,
    //       icon: <ReportIcon className="sidebar-icon-color" />,
    //       label: "Pay Components",
    //       link: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/salary-components/`,
    //       show: true,
    // viewType:'box-view',//
    // category: "payroll",
    //     },
    //     {
    //       key: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/salary-breakdown/`,
    //       icon: <ReportIcon className="sidebar-icon-color" />,
    //       label: "Pay Breakdown",
    //       link: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/salary-breakdown/`,
    //       show: true,
    // viewType:'box-view',//
    // category: "payroll",
    //     },

    //     {
    //       key: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/salary-structure/`,
    //       icon: <ReportIcon className="sidebar-icon-color" />,
    //       label: "Pay Structures",
    //       link: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/salary-structure/`,
    //       show: true,
    // viewType:'box-view',//
    // category: "payroll",
    //     },
    //     {
    //       key: `/${userType === "admin" ? userType : "manager"}/tax-setting/`,
    //       icon: <ReportIcon className="sidebar-icon-color" />,
    //       label: "Tax Structure",
    //       link: `/${userType === "admin" ? userType : "manager"}/tax-setting/`,
    //       show: industry.includes("tax"),
    // viewType:'box-view',//
    // category: "payroll",
    //     },
    //     {
    //       key: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/payroll-air-ticket/`,
    //       icon: <ReportIcon className="sidebar-icon-color" />,
    //       label: "Air Ticket Settings",
    //       link: `/${
    //         userType === "admin" ? userType : "manager"
    //       }/payroll-air-ticket/`,
    //       show: industry.includes("airTicket"),
    // viewType:'box-view',//
    // category: "payroll",
    //     },
    //   ],
    // },
    {
      key: `/${userType === "admin" ? userType : "manager"}/report/`,
      icon: <ReportIcon className="sidebar-icon-color" />,
      label: "Report",
      link: `/${userType === "admin" ? userType : "manager"}/report/`,
      show:
        (userType === "admin" ||
          (userType !== "user" && roleFeatures?.includes("64"))) &&
        industry.includes("report"),
      viewType: "box-view",
      category: "none",
    },
    // {
    //   key: `/${userType === "admin" ? userType : "manager"}/recruitment/`,
    //   icon: (
    //     <ContactsOutlined
    //       style={{ fontSize: "20px" }}
    //       className="sidebar-icon-color"
    //     />
    //   ),
    //   label: "Recruitment",
    //   link: `/${userType === "admin" ? userType : "manager"}/recruitment/`,
    //   show: industry !== "recruitment",
    // },
  ];
};
//   const sortedMenuItems = menuItems.sort((a, b) => {
//     const getViewTypePriority = (item) => {
//       // Check if the item has children and get the first child's viewType
//       if (item.children && item.children.length > 0) {
//         const childViewType = item.children[0].viewType;
//         return childViewType === "box-view" ? 0 : 1;
//       }
//       // If no children, return a default priority based on the item's viewType
//       return item.viewType === "box-view" ? 0 : 1;
//     };

//     // Get priorities for sorting
//     const aPriority = getViewTypePriority(a);
//     const bPriority = getViewTypePriority(b);

//     return aPriority - bPriority;
//   });
//   const allChildren = sortedMenuItems.flatMap((item) => item.children || []);
//   const sidebarDrawerMenuItem = (item2) => css`
//     transition: color 0.3s ease-in-out, background-color 0.6s ease-in-out,
//       border 0.3s ease-in-out;
//     padding: 0px 15px;
//     margin: 12px 0px;
//     height: 25px;
//     display: flex;
//     width: 100%;
//     height: 35px;
//     color: ${themeDefault?.info?.newConfig?.color};
//     &:hover {
//       .ant-typography {
//         color: ${themeDefault?.info?.colorPrimary} !important;
//       }
//       // border-bottom: 1px solid ${themeDefault?.info?.colorPrimary};
//     }

//     .ant-typography {
//       color: ${current === item2?.key
//         ? `${themeDefault?.info?.colorPrimary}`
//         : `${themeDefault?.info?.newConfig?.color}`} !important;
//       border-bottom: ${current === item2?.key
//         ? `2px solid ${themeDefault?.info?.colorPrimary}`
//         : "2px solid transparent"};
//     }

//     :where(.css-dev-only-do-not-override-mg9lgc).ant-menu-inline
//       .ant-menu-item {
//       line-height: 0px !important;
//     }
//   `;
